export const formatProviderLabel = (
  name?: string,
  title?: string,
): string | undefined => {
  if (!name) return undefined;

  return title ? `${name}, ${title}` : name;
};
